import data from "../../data";

export default id => data[String(id)];
